module.exports = __webpack_public_path__ + "img/empty-state-hand.217a4f54.svg";